/**
 * Prosumer Calculator — Main page component.
 *
 * Renders the 4-step prosumer wizard for PV/EV/Heat Pump analysis.
 */

import { Container } from '@mantine/core';
import { Layout } from '../../shared/components';
import { useAuth } from '../auth';
import { useSEO } from '../../shared/hooks';
import { ProsumerWizard } from './components/wizard/ProsumerWizard';

export function ProsumerCalculator() {
  const { isAuthenticated } = useAuth();

  useSEO({
    title: 'Kalkulator Prosumenta',
    description: 'Porównaj taryfy dla prosumentów z fotowoltaiką, autem elektrycznym i pompą ciepła. Net-billing i net-metering.',
  });

  return (
    <Layout isAuthenticated={isAuthenticated}>
      <Container size="lg" py="xl">
        <ProsumerWizard />
      </Container>
    </Layout>
  );
}
